"use client";

import { BlogLink, Content, Header } from "@/components/shared/public/blogs";
import { useTranslations } from "next-intl";
import {
  header,
  section1,
  section2,
  section3,
} from "../../../../../../public/images/blogs/floorPlanVacationProperty";

export default function BlogContent() {
  const t = useTranslations("blogs.floorPlanVacationProperty");

  return (
    <>
      <Header
        title={t("header.title")}
        text={t("header.text")}
        src={section2}
        alt={t("sections.section2.imageAlt")}
      />
      <div className="gs--blog-body flex flex-col gap-10 py-16">
        <Content
          imageFit="cover"
          title={t("sections.section1.title")}
          text={t.rich("sections.section1.text", {
            br: () => <br></br>,
            link: (chunks) => (
              <BlogLink href="/blog/schnitte-und-ansichten">{chunks}</BlogLink>
            ),
            link1: (chunks) => (
              <BlogLink href="/blog/hausgrundriss">{chunks}</BlogLink>
            ),
            link2: (chunks) => (
              <BlogLink href="/blog/grundriss-einer-wohnung">{chunks}</BlogLink>
            ),
          })}
          src={section1}
          alt={t("sections.section1.imageAlt")}
          imageLeft={true}
        />
        <Content
          imageFit="cover"
          title={t("sections.section2.title")}
          text={t.rich("sections.section2.text", {
            br: () => <br></br>,
            link: (chunks) => (
              <BlogLink href="/blog/immobilienmarketing">{chunks}</BlogLink>
            ),
            link1: (chunks) => (
              <BlogLink href="/blog/expose">{chunks}</BlogLink>
            ),
          })}
          src={header}
          alt={t("header.imageAlt")}
        />
        <Content
          imageFit="cover"
          title={t("sections.section3.title")}
          text={t.rich("sections.section3.text", {
            br: () => <br></br>,
            link: (chunks) => (
              <BlogLink href="/blog/wohnflaeche">{chunks}</BlogLink>
            ),
            link1: (chunks) => (
              <BlogLink href="/blog/schnitte-und-ansichten">{chunks}</BlogLink>
            ),
            link2: (chunks) => (
              <BlogLink href="/blog/grundriss">{chunks}</BlogLink>
            ),
            link3: (chunks) => (
              <BlogLink href="/blog/wohnflaeche">{chunks}</BlogLink>
            ),
          })}
          src={section3}
          alt={t("sections.section3.imageAlt")}
          imageLeft={true}
          disclaimer="default"
        />
      </div>
    </>
  );
}
